import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AgencyConfigState } from './agencyConfig.reducer';

export const agencyConfigStateSelector =
  createFeatureSelector<Readonly<AgencyConfigState>>('agencyConfig');

export const agencyConfigSelector = createSelector(
  agencyConfigStateSelector,
  (state) => {
    return state.agencyConfig;
  }
);
export const isSeconKeySelector = createSelector(
  agencyConfigStateSelector,
  (state) => {
    return state.agencyConfig?.isSeconKey;
  }
);
